module.exports = __webpack_public_path__ + "static/media/pharmacy.ceca85c4.svg";